// This constant defines the grid layout for our gutters and containers.
// We may need to tweak this around, but the mobile layouts currently need their gutters defined in the grid, so video can stretch to edges.

export default [
  `15px auto 15px`,
  `15px auto 15px`,
  `minmax(0, 1fr) minmax(0, 1fr)`
]
